<div class="event-container" *ngIf="specialPointsEvent && specialPointsEvent.type === 'referral_points_event'">
  <app-referral-points-event-preview [specialPointsEvent]="specialPointsEvent"></app-referral-points-event-preview>
</div>

<!-- 1:1 port of core's app/views/application/special_points_events/special_points_event.svg.erb (new card design) -->
<div class="event-container" *ngIf="specialPointsEvent && specialPointsEvent.type !== 'referral_points_event'">
  <svg height="100%" width="100%" viewBox="0 0 1160 790">
    <svg
      id="card_bg"
      x="63"
      y="70"
      width="1033.947"
      height="649.987"
      viewBox="0 0 706 442"
      preserveAspectRatio="none"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink">
      <defs>
        <rect id="card" width="706" height="442" rx="48"></rect>
        <mask id="cut">
          <use xlink:href="#card" fill="#FFFFFF"></use>
          <ellipse cx="706" cy="221" rx="34" ry="34.5"></ellipse>
        </mask>
      </defs>
      <g mask="url(#cut)">
        <use xlink:href="#card" [attr.fill]="bgColor"></use>
        <path
          [attr.fill]="accentColor"
          transform="matrix(-4.37114e-08 -1 1 -4.37114e-08 550.341 587.11)"
          d="M432.11572 65.052979L476.63437 20.402044C449.51224 -6.8006811 405.5415 -6.8006811 378.41937 20.402044C373.21411 25.622768 368.96774 31.53043 365.81717 37.781563C362.59814 31.53043 358.35175 25.622768 353.14648 20.402044C326.02435 -6.8006811 282.05365 -6.8006811 254.93152 20.402044L299.45016 65.052979L0 65.052979L0 281.31842L733.22058 281.31842L733.22058 65.052979L432.11572 65.052979Z"
          fill-rule="evenodd"></path>
      </g>
    </svg>

    <svg
      x="63"
      y="70"
      width="1033.947"
      height="649.987"
      viewBox="0 0 706 442"
      preserveAspectRatio="none"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink">
      <g transform="translate(48, 52)">
        <rect [attr.width]="badgeWidth" height="101" rx="50" [attr.fill]="accentColor"></rect>
        <text
          [attr.x]="badgeWidth / 2"
          y="68"
          text-anchor="middle"
          font-family="Sora"
          font-size="50"
          font-weight="600"
          fill="white">
          {{ badgeLabel }}
        </text>
      </g>

      <g *ngIf="specialPointsEvent?.partner?.logo" [attr.transform]="'translate(' + (48 + badgeWidth + 26) + ', 50)'">
        <circle cx="53" cy="53" r="53" fill="white"></circle>
        <mask id="circle-mask">
          <circle cx="53" cy="53" r="46" fill="white"></circle>
        </mask>
        <image
          [attr.xlink:href]="specialPointsEvent?.partner?.logo"
          x="7"
          y="7"
          width="92"
          height="92"
          mask="url(#circle-mask)"></image>
      </g>

      <g transform="translate(48, 322)" font-family="Sora" fill="white">
        <text font-size="28" font-weight="600">
          Auf deinen nächsten Einkauf{{
            !specialPointsEvent.extra_points_threshold || specialPointsEvent.type === "points_multiplier_event"
              ? ""
              : " ab " + specialPointsEvent.extra_points_threshold + "€"
          }}
        </text>

        <g transform="translate(0, 36)" *ngIf="recurring_event">
          <ng-container *ngIf="recurring_event.rule === 'singular'">
            <ng-container *ngIf="isSingleDayEvent()">
              <text font-size="25" font-weight="300">Gültig am {{ recurring_event.starts_at | date: "fullDate" }}</text>
              <text transform="translate(0, 34)" font-size="25" font-weight="300">
                von {{ recurring_event.starts_at | date: "H:mm" }} bis {{ recurring_event.ends_at | date: "H:mm" }} Uhr
              </text>
            </ng-container>
            <ng-container *ngIf="!isSingleDayEvent()">
              <text font-size="25" font-weight="300">
                Gültig ab {{ recurring_event.starts_at | date: "EE, d.M.yyyy H:mm" }} Uhr
              </text>
              <text transform="translate(0, 34)" font-size="25" font-weight="300">
                bis {{ recurring_event.ends_at | date: "EE, d.M.yyyy H:mm" }}
                Uhr
              </text>
            </ng-container>
          </ng-container>
          <ng-container *ngIf="recurring_event.rule === 'daily'">
            <text font-size="25" font-weight="300">
              Gültig jeden Tag von {{ recurring_event.starts_at | date: "H:mm" }} Uhr bis
              {{ recurring_event.ends_at | date: "H:mm" }} Uhr
            </text>
          </ng-container>
          <ng-container *ngIf="recurring_event.rule === 'weekly'">
            <text font-size="25" font-weight="300">Gültig jeden {{ getWeekdays() }}</text>
            <text transform="translate(0, 34)" font-size="25" font-weight="300">
              von {{ recurring_event.starts_at | date: "H:mm" }} Uhr bis
              {{ recurring_event.ends_at | date: "H:mm" }} Uhr
            </text>
          </ng-container>
          <ng-container *ngIf="recurring_event.rule === 'monthly'">
            <text font-size="25" font-weight="300">
              Gültig jeden Monat am {{ recurring_event.starts_at | date: "d." }}
            </text>
            <text transform="translate(0, 34)" font-size="25" font-weight="300">
              von {{ recurring_event.starts_at | date: "H:mm" }} Uhr bis
              {{ recurring_event.ends_at | date: "H:mm" }} Uhr
            </text>
          </ng-container>
          <ng-container *ngIf="recurring_event.rule === 'yearly'">
            <text font-size="25" font-weight="300">
              Gültig jedes Jahr am {{ recurring_event.starts_at | date: "d. LLLL" }}
            </text>
            <text transform="translate(0, 34)" font-size="25" font-weight="300">
              von {{ recurring_event.starts_at | date: "H:mm" }} Uhr bis
              {{ recurring_event.ends_at | date: "H:mm" }} Uhr
            </text>
          </ng-container>
        </g>
      </g>
    </svg>
  </svg>
</div>
